module.exports = __webpack_public_path__ + "static/media/brinquedo13.b3de3b88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo13.jpg
// module id = 69
// module chunks = 0